import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { OptionService } from "../option/option.service";

export interface CountryResponse {
    data: Array<Country>;
    success: boolean;
}

export interface Country {
    code: string;
    country: string;
}

@Injectable({
    providedIn: 'root'
})

export class CountryService {
    /**
     * URL for getting the list of countries from the API
     * @private
     */
    private apiUrl = 'country/';

    /**
     * List of Fallback countries.
     * @private
     */
    private fallbackCountries: CountryResponse = {
      success: false,
      data: [
        { code: 'DE', country: 'Deutschland' },
        { code: 'AT', country: 'Österreich' },
        { code: 'CH', country: 'Schweiz' }
      ]
    };

    /**
     * constructor
     * @param http
     */
    constructor(private http: HttpClient) { }

    /**
     * get countries from api
     * @returns Observable
     */
    getCountriesFromAPI(): Observable<CountryResponse> {
        const host = OptionService.getLookupHost();
        let countryGroup = OptionService.getOptionStatic('country_group');
        if (countryGroup === null || countryGroup.length === 0) {
          countryGroup = "";
        }

        return this.http.get<CountryResponse>(`${host}${this.apiUrl}${countryGroup}`).pipe(
            map(result => {
              if (result.hasOwnProperty("data") === false || result.data.length === 0) {
                return this.fallbackCountries
              }
              return result;
            }),
            catchError((error: any) => {
                console.error('Could not load countries:', error);
                // return germany if the request fails
                return of(this.fallbackCountries);
            })
        );
    }
}
